<template>
  <TooltipProvider
    :disable-closing-trigger="disableClosingTrigger"
  >
    <Tooltip :disabled="disabled">
      <TooltipTrigger
        v-bind="$attrs"
        as-child
      >
        <slot>
          <i :class="cn('tw:i-fad-circle-info tw:text-[#B5B5BC]', $props.class)" />
        </slot>
      </TooltipTrigger>
      <TooltipContent
        :side="side"
        :align="align"
        :side-offset="sideOffset"
      >
        <slot name="content">
          <div>
            <a
              v-if="canonical"
              target="_blank"
              :href="`https://dubb.com/v/${canonical}`"
            >
              <img
                class="tw:w-full tw:rounded"
                :src="`https://dubb.com/v/${canonical}/preview_with_play.png`"
                alt=""
              >
            </a>

            <div
              class="tw:text-left"
            >
              <template v-if="text">
                <span>{{ text }}</span>
              </template>

              <a
                v-if="readMore"
                :href="readMore"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="tw:i-fal-external-link-alt tw:text-white" />
              </a>
            </div>
          </div>
        </slot>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<script setup>
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shadcn/components/ui/tooltip'
import { cn } from '@/shadcn/lib/utils.js'

defineOptions({
  inheritAttrs: false,
})

defineProps({
  canonical: {
    type: String,
    required: false,
  },
  text: {
    type: String,
    required: false,
  },
  readMore: {
    type: String,
    required: false,
  },
  class: {
    type: null,
    required: false,
  },
  disableClosingTrigger: {
    type: Boolean,
    default: false,
  },
  side: {
    type: String,
    default: 'top',
  },
  sideOffset: {
    type: Number,
    required: false,
    default: -4,
  },
  align: {
    type: String,
    default: 'center',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>
